import { PencilBoxIcon } from './PencilBoxIcon';

/**
 * author: Austin Andrews
 * id 56CC04F4-4E58-434D-962A-C824F5959D20
 * name pencil-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-box.svg
 * tags
 * - Drawing / Art 
 */
export const EditBoxIcon = PencilBoxIcon;
export default EditBoxIcon